import {http, onSuccess, onFail} from './http';

export const getFonts = () =>
    http.get('/api/cp/event/module/theme/fonts')
        .then(onSuccess, onFail);

export const updateFontsList = (data) =>
    http.post('/api/cp/event/module/theme/fonts', data, {headers: {
            'content-type': 'multipart/form-data',
        }})
        .then(onSuccess, onFail);


export const deleteFont = (id) =>
    http.delete(`/api/cp/event/module/theme/fonts/${id}`)
        .then(onSuccess, onFail);

